import type { GridColDef } from '@mui/x-data-grid-pro';
import type { OutcomeType } from '../../@types/api';
import { QUERY_KEYS } from '../../constants';
import { createDescriptionColumn, createEditColumn } from '../../helpers/columns';
import { defaultColumnsOutcomes } from '../../helpers/table';
import useMutateData from '../../hooks/useMutateData';
import { usePagination } from '../../hooks/usePagination';
import useSort from '../../hooks/useSort';
import { createColumn } from '../../utils';
import Switch from '../atoms/Switch';
import EditTableItem from '../organisms/EditTableItem';
import TableTemplate from '../templates/TableTemplate';
import { getMarketTypeName } from '../../helpers';
import { useLocation } from 'react-router';
import { useEffect } from 'react';

const OutcomeTypesPage = () => {
  const {
    data: outcomesData,
    updateQueryParams,
    isFetching,
    isLoading,
    changeQuery,
  } = usePagination<OutcomeType>('outcome-types');
  const { deleteData, updateData } = useMutateData('outcome-types', [QUERY_KEYS.outcomeTypes]);
  const { handleSort } = useSort(changeQuery);

  const { state } = useLocation();

  useEffect(() => {
    if (state?.defaultFilters) {
      changeQuery({
        ...state?.defaultFilters,
        isActive: undefined,
        language: undefined,
      });
    }
  }, [changeQuery, state?.defaultFilters]);

  const handleSearch = (value: string | null) => {
    changeQuery({ search: value });
  };

  const columns: GridColDef[] = [
    createColumn('id', 'ID', { sortable: false }),
    createColumn('sportName', 'Sport', {
      valueGetter: (value, row, column, apiRef) => row.sport.name,
    }),
    createColumn('marketTypeName', 'Market', {
      minWidth: 200,
      valueGetter: (value, row, column, apiRef) => getMarketTypeName(row.marketType),
    }),
    createColumn('name', 'Outcome Name', {
      minWidth: 150,
    }),
    createColumn('shortName', 'Outcome Short Name'),
    createColumn('position', 'Position'),
    createDescriptionColumn(),
    createColumn('isActive', 'Status', {
      renderCell: (params) => {
        return (
          <Switch
            value={params.value}
            onChange={(e) => {
              updateData(params.row.id, { isActive: e.target.checked });
            }}
            name='status'
          />
        );
      },
    }),
    createEditColumn({
      deleteData,
      columnName: 'Actions',
    }),
  ];

  return (
    <TableTemplate
      rows={outcomesData?.items || []}
      columns={columns}
      loading={isFetching || isLoading}
      rowCount={outcomesData?.count || 0}
      createItemBtnLabel='Add new outcome'
      defaultVisibleColumns={defaultColumnsOutcomes}
      handlePaginationModelChange={updateQueryParams}
      handleSearch={handleSearch}
      handleSort={handleSort}
      changeQuery={changeQuery}
      formType='outcomes'
      showExport
    />
  );
};

export default OutcomeTypesPage;
